import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const sandboxBundlerRoute: InvariantJiraRoute = {
	name: 'sandbox-bundler',
	path: '/jira/software/sandbox/bundler',
	exact: true,
};
